import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { production, useRemoteI18nFiles } from '@env';
import { preferredLanguage } from '@blockframes/model';
import { initLanguage } from '@blockframes/utils/i18n/init';

if (production) {
  enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
});

initLanguage(preferredLanguage(), { loadTranslations: true, useRemoteI18nFiles });

